import React, { useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import { useCountDown } from 'ahooks';
import dynamic from 'next/dynamic';
import Dialog from './Dialog';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import EcoIconArrowButton from 'eco-design-micro/icons/eco-icon-arrow-button';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';

interface Props {
    endTime: number;
}

const Countdown = dynamic(() => import('./Countdown'), {
    ssr: false, // 关键点：关闭服务端渲染
});

const EarlyBird: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('powerBank.EarlyBird');

    const list = [
        {
            title: t('item1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1752113166423/1.png',
        },
        {
            title: t('item2'),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1754560289246/icon_12.png',
            // link: `/${router.locale}/ecocredits`,
        },
        {
            title: t('item3'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749535012867/off5.png',
        },
        {
            title: t('item4'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1752113166990/4.png',
        },
    ];

    // 倒计时
    const [, formattedRes] = useCountDown({ targetDate: endTime });

    // 弹窗
    const [open, setOpen] = useState(false);

    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (systemTime >= endTime) return null;

    return (
        <div id="EarlyBird_US" className={`EarlyBird_US GtmModuleData-section`} data-section-id={'EarlyBird_US'}>
            <EcoSpace />
            <div className={style.comp}>
                <EcoTitle title={t('title')} />
                <Countdown days={formattedRes.days} hours={formattedRes.hours} minutes={formattedRes.minutes} seconds={formattedRes.seconds} />
                <div className="cards">
                    {list.map((i, idx) => (
                        <div
                            className={`card-item GtmModuleData-btn-href card-item-${idx + 1}`}
                            key={idx}
                            dataLayer={
                                i.link
                                    ? {
                                          __btn_id1: `EarlyBird_US .card-item-${idx + 1}`,
                                          __btn_id2: i.link,
                                          __btn_type: 'href',
                                      }
                                    : {}
                            }
                            onClick={() => {
                                if (i.link) {
                                    router.push(i.link);
                                }
                            }}
                        >
                            <img src={i.pc} alt="" />
                            <div className="card-item-info">
                                <div className="card-item-title">{i.title}</div>
                                <div className="card-item-desc">{i.desc}</div>
                            </div>
                        </div>
                    ))}
                </div>
                <div
                    className="tc-btn GtmModuleData-btn-text"
                    onClick={() => {
                        gtm.push({
                            __btn_id1: 'EarlyBird_US .tc-btn',
                            __btn_id2: t('footer'),
                            __btn_type: 'text',
                        });
                        setOpen(true);
                    }}
                >
                    {t('footer')}
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} />
        </div>
    );
};
export default EarlyBird;
